/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */
import React from 'react';
import IconComponent from '@atlaskit/icon-lab/core/page-live-doc';
import ObjectBase from '../object-base';
export default function PageLiveDocObject(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Page Live Doc' : _ref$label,
    size = _ref.size,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(ObjectBase, {
    label: label,
    size: size,
    testId: testId,
    icon: IconComponent,
    color: "var(--ds-icon-accent-magenta, #CD519D)"
  });
}